/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Single Post page
    $('.article-detail__slideshow').slick({
      'prevArrow':'<button type="button" class="slick-prev"><i class="far fa-angle-left fa-2x"></i></button>',
      'nextArrow': '<button type="button" class="slick-next"><i class="far fa-angle-right fa-2x"></i></button>'
    });

    // matchHeight.js
    $(() => {
      $('.blog__post-content-wrapper').matchHeight();
    });

    // Match image height to container
    // $('.article-detail__two-column-image-wrapper').each(function() {
    //   var self = $(this);
    //   var containerHeight = self.siblings().height();
    //   self.find('.article-detail__image').css('height', containerHeight + 'px');
    // });

    // Match featured product height to container
    $('.article-detail__featured-product-wrapper').each(function() {
      const self = $(this);
      const textHeight = self.find('.featured-product__text').height();
      const productContentHeight = self.find('.featured-product__post-content').height();
      const containerHeight = textHeight - productContentHeight;
      self.find('.featured-product__post-image').css('height', `${containerHeight}px`);
      $.fn.matchHeight._update();
    });

    // Google map constructor
    function new_map( $el ) {
      // var
      const $markers = $el.find('.marker');

      // vars
      const args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      // create map
      const map = new google.maps.Map( $el[0], args);

      // add a markers reference
      map.markers = [];

      // add markers
      $markers.each(function(){
        add_marker( $(this), map );
      });

      // center map
      center_map( map );

      // return
      return map;
    }

    // Add map marker
    function add_marker( $marker, map ) {
      // var
      const latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

      const markerPin = {
        path: 'M5.8,0C2.6,0,0,2.6,0,5.8c0,3.1,5.3,8.8,5.5,9C5.6,14.9,5.7,15,5.8,15s0.2,0,0.3-0.1c0.2-0.2,5.5-5.9,5.5-9  C11.7,2.6,9,0,5.8,0z M5.8,7.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S7.2,7.7,5.8,7.7z',
        fillColor: '#ce3262',
        fillOpacity: 1,
        scale: 2,
        strokeWeight: 0
      };

      // create marker
      const marker = new google.maps.Marker({
        position: latlng,
        map,
        icon: markerPin
      });

      // add to array
      map.markers.push( marker );

      // if marker contains HTML, add it to an infoWindow
      if ( $marker.html() ) {
        // create info window
        const infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', () => {
          infowindow.open( map, marker );
        });
      }
    }

    // Center the map
    function center_map( map ) {
      // vars
      const bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, (i, marker) => {
        const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
        bounds.extend( latlng );
      });

      // only 1 marker?
      if( map.markers.length == 1 ) {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 16 );
      }
      else {
        // fit to bounds
        map.fitBounds( bounds );
      }
    }

    // global var
    let map = null;

    // Load map when document is ready
    $(document).ready(() => {
      $('.acf-map').each(function(){
        // create map
        map = new_map( $(this) );
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the Single Post page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js